module.exports = __webpack_public_path__ + "static/media/m-snowfight.f58a37b4.png";